import { render } from "./GitHubCorner.vue?vue&type=template&id=3c8859d0"
import script from "./GitHubCorner.vue?vue&type=script&lang=js"
export * from "./GitHubCorner.vue?vue&type=script&lang=js"

import "./GitHubCorner.vue?vue&type=style&index=0&id=3c8859d0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__